module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/3-6bee2308005a7386b545d5e72f4d1117.svg";